export const en = {
  "app.name": "YourCV",
  "app.tagline": "A CV that looks like you.",

  "nav.signIn": "Sign in",
  "nav.signOut": "Sign out",
  "nav.dashboard": "Your CVs",
  "nav.templates": "Templates",
  "nav.billing": "Billing",
  "nav.organizations": "Organizations",
  "nav.settings": "Settings",
  "nav.accountMenu": "Account menu",

  "common.save": "Save",
  "common.saved": "Saved",
  "common.saving": "Saving…",
  "common.saveFailed": "Could not save",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.copy": "Copy",
  "common.copied": "Copied",
  "common.close": "Close",
  "common.add": "Add",
  "common.remove": "Remove",
  "common.back": "Back",
  "common.done": "Done",
  "common.loading": "Loading…",
  "common.retry": "Try again",
  "common.search": "Search",
  "common.preview": "Preview",
  "common.print": "Print",
  "common.share": "Share",
  "common.upgrade": "Upgrade",
  "common.free": "Free",
  "common.pro": "Pro",
  "common.month": "Monthly",
  "common.year": "Yearly",
  "common.savePercent": "Save 20%",
  "common.moreOptions": "More options",
  "common.pickColor": "Pick a color",
  "common.optional": "Optional",
  "common.confirm": "Confirm",
  "common.dismiss": "Dismiss",
  "common.language": "Language",
  "theme.label": "Theme",
  "theme.switchToLight": "Switch to light mode",
  "theme.switchToDark": "Switch to dark mode",
  "common.english": "English",
  "common.vietnamese": "Tiếng Việt",
  "common.open": "Open",
  "common.create": "Create",
  "common.new": "New",
  "common.rename": "Rename",
  "common.duplicate": "Duplicate",
  "common.working": "Working…",
  "common.moveUp": "Move up",
  "common.moveDown": "Move down",
  "common.menu": "Menu",
  "common.retrySave": "Retry",

  "landing.heroTitle": "A CV that looks like you.",
  "landing.heroSubtitle": "Write once. Pick a template. Share a link or print.",
  "landing.cta": "Create your CV",
  "landing.secondary": "See templates",
  "landing.proofTemplates": "Eight calm, print-ready templates",
  "landing.proofPrivacy": "Private by default",
  "landing.proofExport": "Share a link, embed, or print",
  "landing.templatesTitle": "Templates",
  "landing.viewAll": "View all",
  "landing.stepsTitle": "Three steps",
  "landing.step1": "Add your story",
  "landing.step2": "Choose a template",
  "landing.step3": "Share or print",
  "landing.pricingTitle": "Simple pricing",
  "landing.pricingSubtitle": "Start free. Upgrade when you need more.",
  "landing.freePrice": "Free",
  "landing.proPrice": "$8 / month",
  "landing.freeFeature1": "Two CVs",
  "landing.freeFeature2": "20 MB of images",
  "landing.freeFeature3": "Five templates",
  "landing.freeFeature4": "Public link and print",
  "landing.proFeature1": "Up to 100 CVs",
  "landing.proFeature2": "200 MB of images",
  "landing.proFeature3": "All eight templates",
  "landing.proFeature4": "No badge",
  "landing.footerNote": "Made for people who care about the details.",
  "landing.previewName": "Nguyen Van A",
  "landing.previewHeadline": "Senior Frontend Engineer",

  "auth.welcomeBack": "Welcome back.",
  "auth.createAccount": "Create your account.",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.name": "Name",
  "auth.signIn": "Sign in",
  "auth.signUp": "Create account",
  "auth.google": "Continue with Google",
  "auth.facebook": "Continue with Facebook",
  "auth.x": "Continue with X",
  "auth.or": "or",
  "auth.socialError": "We could not sign you in with that provider. Try again.",
  "auth.noAccount": "New here?",
  "auth.haveAccount": "Already have an account?",
  "auth.forgot": "Forgot your password?",
  "auth.passwordHint": "Use 8 characters or more.",
  "auth.resetTitle": "Reset your password.",
  "auth.resetSubtitle": "We will email you a link.",
  "auth.sendLink": "Send link",
  "auth.resetSent": "Check your email for the link.",
  "auth.newPassword": "New password",
  "auth.confirmPassword": "Confirm password",
  "auth.passwordsDiffer": "Passwords do not match.",
  "auth.resetAction": "Set new password",
  "auth.resetDone": "Your password has been updated. You can sign in now.",
  "auth.resetInvalid": "This link is invalid or has expired. Request a new one.",
  "auth.invalidEmail": "Enter a valid email address.",
  "auth.passwordShort": "Use at least 8 characters.",
  "auth.nameRequired": "Enter your name.",
  "auth.invalidCredentials": "Email or password is incorrect.",
  "auth.emailTaken": "An account with this email already exists.",
  "auth.tooManyAttempts": "Too many attempts. Try again shortly.",
  "auth.genericError": "We could not complete that. Try again.",
  "auth.verifyTitle": "Check your inbox.",
  "auth.verifyBody": "Open the link in the email to finish signing up.",
  "auth.backToSignIn": "Back to sign in",

  "dashboard.title": "Your CVs",
  "dashboard.count": "{count} total",
  "dashboard.newCv": "New CV",
  "dashboard.emptyTitle": "No CVs yet.",
  "dashboard.emptyBody": "Create your first CV in a minute.",
  "dashboard.edited": "Edited {when}",
  "dashboard.quota": "{used} of {limit} CVs",
  "dashboard.upgradeTitle": "More room, every template.",
  "dashboard.upgradeBody": "Pro gives you 100 CVs, 200 MB, and no badge.",
  "dashboard.untitled": "Untitled CV",
  "dashboard.deleteConfirm": "Delete this CV? You can restore it for 30 days.",
  "dashboard.searchPlaceholder": "Search your CVs",
  "dashboard.justNow": "just now",
  "dashboard.yesterday": "yesterday",
  "dashboard.daysAgo": "{count} days ago",

  "editor.profile": "Profile",
  "editor.experience": "Experience",
  "editor.education": "Education",
  "editor.projects": "Projects",
  "editor.skills": "Skills",
  "editor.languages": "Languages",
  "editor.certifications": "Certifications",
  "editor.awards": "Awards",
  "editor.links": "Links",
  "editor.addExperience": "Add experience",
  "editor.addEducation": "Add education",
  "editor.addProject": "Add project",
  "editor.addSkill": "Add skill",
  "editor.addLanguage": "Add language",
  "editor.addCertification": "Add certification",
  "editor.addAward": "Add award",
  "editor.addLink": "Add link",
  "editor.emptyExperience": "Add your first role.",
  "editor.emptyEducation": "Add your first school.",
  "editor.emptyProjects": "Add a project you are proud of.",
  "editor.emptySkills": "Add a skill.",
  "editor.emptyLanguages": "Add a language.",
  "editor.emptyCertifications": "Add a certification.",
  "editor.emptyAwards": "Add an award.",
  "editor.emptyLinks": "Add a link.",
  "editor.dragHint": "Drag to reorder",
  "editor.templateChanged": "Template updated",
  "editor.sectionsTitle": "Sections",
  "editor.hideSection": "Hide section",
  "editor.showSection": "Show section",
  "editor.previewTab": "Preview",
  "editor.formTab": "Edit",
  "editor.unsaved": "Unsaved changes",
  "editor.savedAll": "All changes saved",
  "editor.errorSave": "We could not save. Retrying…",
  "editor.titlePlaceholder": "CV title",

  "profile.fullName": "Full name",
  "profile.headline": "Headline",
  "profile.email": "Email",
  "profile.phone": "Phone",
  "profile.location": "Location",
  "profile.summary": "Summary",
  "profile.avatar": "Photo",
  "profile.uploadPhoto": "Upload photo",
  "profile.removePhoto": "Remove photo",
  "profile.showEmail": "Show email on the CV",
  "profile.showPhone": "Show phone on the CV",
  "profile.summaryHint": "Two or three sentences. What do you do best?",

  "experience.company": "Company",
  "experience.role": "Role",
  "experience.location": "Location",
  "experience.employmentType": "Type",
  "experience.startDate": "Start",
  "experience.endDate": "End",
  "experience.current": "I work here now",
  "employment.fullTime": "Full-time",
  "employment.partTime": "Part-time",
  "employment.contract": "Contract",
  "employment.internship": "Internship",
  "employment.freelance": "Freelance",
  "experience.highlights": "Highlights",
  "experience.highlightPlaceholder": "One result per line",

  "education.institution": "School",
  "education.degree": "Degree",
  "education.fieldOfStudy": "Field",
  "education.location": "Location",
  "education.startDate": "Start",
  "education.endDate": "End",
  "education.current": "I study here now",
  "education.description": "Notes",

  "projects.name": "Project",
  "projects.role": "Your role",
  "projects.description": "Description",
  "projects.url": "Live URL",
  "projects.repoUrl": "Repository",
  "projects.startDate": "Start",
  "projects.endDate": "End",
  "projects.current": "Ongoing",
  "projects.highlights": "Highlights",
  "projects.tech": "Tech",
  "projects.techPlaceholder": "TypeScript, React, Cloudflare",
  "projects.featured": "Feature this project",
  "projects.image": "Image",
  "projects.uploadImage": "Upload image",
  "projects.removeImage": "Remove image",

  "skills.name": "Skill",
  "skills.category": "Category",
  "skills.level": "Level",

  "languages.name": "Language",
  "languages.proficiency": "Proficiency",
  "languages.native": "Native",
  "languages.fluent": "Fluent",
  "languages.professional": "Professional",
  "languages.limited": "Working knowledge",

  "certifications.name": "Certification",
  "certifications.issuer": "Issuer",
  "certifications.issueDate": "Issued",
  "certifications.expiryDate": "Expires",
  "certifications.credentialId": "Credential ID",
  "certifications.credentialUrl": "Credential URL",

  "awards.title": "Award",
  "awards.issuer": "Issuer",
  "awards.date": "Date",
  "awards.description": "Description",

  "links.type": "Type",
  "links.label": "Label",
  "links.url": "URL",
  "links.linkedin": "LinkedIn",
  "links.github": "GitHub",
  "links.website": "Website",
  "links.portfolio": "Portfolio",
  "links.email": "Email",
  "links.custom": "Custom",

  "templates.title": "Templates",
  "templates.all": "All",
  "templates.use": "Use template",
  "templates.previous": "Previous template",
  "templates.next": "Next template",
  "templates.current": "Current",
  "templates.proRequired": "This template is available on Pro.",
  "templates.upgradeBody": "Unlock all eight templates and remove the badge.",
  "templates.upgradeCta": "See Pro",
  "templates.chooseCv": "Choose a CV",
  "templates.apply": "Apply",
  "templates.classic.name": "Classic",
  "templates.classic.description": "A serif CV with quiet authority.",
  "templates.minimal.name": "Minimal",
  "templates.minimal.description": "Space, clarity, and one accent.",
  "templates.mono.name": "Mono",
  "templates.mono.description": "Technical and precise.",
  "templates.editorial.name": "Editorial",
  "templates.editorial.description": "A magazine headline for your name.",
  "templates.sidebar.name": "Sidebar",
  "templates.sidebar.description": "A two-column layout with a calm rail.",
  "templates.timeline.name": "Timeline",
  "templates.timeline.description": "A clear line through your career.",
  "templates.compact.name": "Compact",
  "templates.compact.description": "Fits a long career on one page.",
  "templates.bold.name": "Bold",
  "templates.bold.description": "A strong name and generous headings.",

  "share.title": "Share",
  "share.linkTab": "Link",
  "share.embedTab": "Embed",
  "share.sdkTab": "SDK",
  "share.visibility": "Visibility",
  "share.private": "Private",
  "share.unlisted": "Unlisted",
  "share.public": "Public",
  "share.privateHint": "Only you can open this CV.",
  "share.unlistedHint": "Anyone with the link can open it.",
  "share.publicHint": "Anyone can open it, and search engines may index it.",
  "share.publish": "Publish to share",
  "share.unpublish": "Make private",
  "share.copy": "Copy link",
  "share.open": "Open",
  "share.pasteInto": "Paste this into any HTML page.",
  "share.install": "Install",
  "share.sdkHint": "Create an app password in Settings.",
  "share.appPasswords": "Settings → App passwords",
  "share.published": "Published",
  "share.badgeNote": "Free CVs show a small badge.",

  "settings.title": "Settings",
  "settings.profileTab": "Profile",
  "settings.securityTab": "Security",
  "settings.appPasswordsTab": "App passwords",
  "settings.languageTab": "Language",
  "settings.dangerTab": "Danger",
  "settings.displayName": "Display name",
  "settings.emailReadonly": "Email",
  "settings.newAppPassword": "New app password",
  "settings.appPasswordName": "Name",
  "settings.scopes": "Permissions",
  "settings.expiry": "Expires",
  "settings.expiry30": "30 days",
  "settings.expiry90": "90 days",
  "settings.expiry365": "1 year",
  "settings.tokenTitle": "Copy this token now",
  "settings.tokenWarning": "It will not be shown again.",
  "settings.revoke": "Revoke",
  "settings.revokeConfirm": "Revoke this app password?",
  "settings.lastUsed": "Last used {when}",
  "settings.expiresOn": "Expires {when}",
  "settings.never": "Never",
  "settings.noAppPasswords": "No app passwords yet.",
  "settings.languageHint": "Changes the app language. Each CV has its own language.",
  "settings.exportData": "Export my data",
  "settings.deleteAccount": "Delete account",
  "settings.dangerBody": "This removes your CVs, images, and subscription.",
  "settings.deleteConfirm": "Type DELETE to confirm",
  "settings.appPasswordLimit": "You can keep ten active app passwords.",
  "settings.saved": "Saved",
  "settings.changePassword": "Change password",
  "settings.currentPassword": "Current password",
  "settings.newPassword": "New password",
  "settings.signOutEverywhere": "Sign out on all devices",
  "settings.passwordChanged": "Password updated.",
  "settings.wrongPassword": "Current password is incorrect.",
  "settings.sessionsRevoked": "Signed out on all other devices.",
  "settings.scopeRead": "Read CVs",
  "settings.scopeWrite": "Edit CVs",
  "settings.scopePublish": "Publish CVs",
  "settings.scopeAssets": "Upload images",

  "billing.title": "Billing",
  "billing.currentPlan": "Current plan",
  "billing.status": "Status",
  "billing.proTitle": "YourCV Pro",
  "billing.proBody": "More room, every template, no badge.",
  "billing.manage": "Manage subscription",
  "billing.checkoutSuccess": "You are on Pro. It may take a moment to appear.",
  "billing.checkoutCancelled": "Checkout was cancelled.",
  "billing.alreadyPro": "You already have Pro.",
  "billing.subscribe": "Upgrade to Pro",
  "billing.portalUnavailable": "Billing is not configured on this deployment.",
  "billing.perMonth": "per month",
  "billing.perYear": "per year",
  "billing.freePlan": "Free",
  "billing.renews": "Renews {date}",
  "billing.ends": "Ends {date}",
  "billing.monthlyPrice": "$8",
  "billing.yearlyPrice": "$76",
  "billing.freeBody": "Two CVs and five templates.",
  "billing.teamTitle": "YourCV Team",
  "billing.teamBody": "Pro for a bundle of people. One subscription, one invoice.",
  "billing.teamCta": "Set up a team",
  "billing.viaOrganization": "Your Pro access comes from an organization.",

  "organization.title": "Organizations",
  "organization.subtitle": "Pay for seats. Every member gets Pro while the team plan is active.",
  "organization.create": "Create organization",
  "organization.createTitle": "Create an organization",
  "organization.name": "Organization name",
  "organization.namePlaceholder": "Acme Recruiting",
  "organization.emptyTitle": "No organizations yet.",
  "organization.emptyBody": "Create one, choose seats, and invite your team.",
  "organization.members": "{count} members",
  "organization.memberCount": "Members",
  "organization.seatCount": "Seats",
  "organization.pendingInvites": "Pending invites",
  "organization.role.owner": "Owner",
  "organization.role.admin": "Admin",
  "organization.role.member": "Member",
  "organization.planActive": "Team plan active",
  "organization.planInactive": "No subscription",
  "organization.open": "Manage",
  "organization.invite": "Invite member",
  "organization.inviteTitle": "Invite a member",
  "organization.inviteEmail": "Email",
  "organization.emailPlaceholder": "name@company.com",
  "organization.inviteRole": "Role",
  "organization.inviteSent": "Invitation created.",
  "organization.inviteLink": "Invitation link",
  "organization.invitePending": "Pending",
  "organization.inviteAccepted": "Accepted",
  "organization.inviteExpired": "Expired",
  "organization.revokeInvite": "Revoke",
  "organization.revokeInviteConfirm": "Revoke this invitation?",
  "organization.copyLink": "Copy link",
  "organization.copied": "Link copied",
  "organization.membersTitle": "Members",
  "organization.invitationsTitle": "Invitations",
  "organization.billingTitle": "Team billing",
  "organization.billingBody":
    "One subscription covers every seat. Members get Pro while the plan is active.",
  "organization.seats": "Seats",
  "organization.seatsHint": "Seats cover members and pending invitations.",
  "organization.subscribeTeam": "Subscribe for {seats} seats",
  "organization.perSeat": "per seat",
  "organization.manageBilling": "Manage team billing",
  "organization.renews": "Renews {date}",
  "organization.ends": "Ends {date}",
  "organization.subscriptionRequired": "Subscribe to invite members.",
  "organization.upgradeTitle": "Pay for people, not software.",
  "organization.upgradeBody":
    "A team subscription covers a bundle of seats. Add or remove people as your team changes.",
  "organization.upgradeCta": "Set up a team",
  "organization.leave": "Leave organization",
  "organization.leaveConfirm": "Leave this organization? Your CVs stay yours.",
  "organization.delete": "Delete organization",
  "organization.deleteConfirm": "Delete this organization and cancel its subscription?",
  "organization.deleteBody":
    "This removes members and pending invitations. Member CVs stay in their own accounts.",
  "organization.rename": "Rename",
  "organization.saved": "Saved",
  "organization.roleChanged": "Role updated",
  "organization.memberRemoved": "Member removed",
  "organization.lastOwner": "Add another owner before leaving.",
  "organization.acceptTitle": "Join {name}",
  "organization.acceptBody": "{email} was invited as {role}.",
  "organization.accept": "Accept invitation",
  "organization.accepted": "You joined the organization.",
  "organization.inviteNotFound": "This invitation is invalid or has expired.",
  "organization.signInToAccept": "Sign in to accept.",
  "organization.backToOrgs": "Back to organizations",
  "organization.noSeats": "No seats available. Increase the plan or remove a pending invitation.",
  "organization.checkoutSuccess": "Team subscription started. It may take a moment to appear.",
  "organization.checkoutCancelled": "Team checkout was cancelled.",
  "organization.portalUnavailable": "Billing is not configured on this deployment.",
  "organization.you": "You",
  "organization.removeMember": "Remove",
  "organization.removeConfirm": "Remove this member? Their CVs stay in their account.",
  "organization.changeRole": "Role",
  "organization.teamPlan": "YourCV Team",
  "organization.teamBody": "Pro for every seat. One bill for the team.",
  "organization.teamFeature1": "Pro limits for every member",
  "organization.teamFeature2": "All templates, no badge",
  "organization.teamFeature3": "Invite and remove people",
  "organization.teamFeature4": "One invoice for the whole team",
  "organization.manage": "Manage organization",
  "organization.status": "Status",
  "organization.ownerOnly": "Only owners can do that.",
  "organization.ownerLeave": "Transfer ownership before leaving.",
  "organization.onlyOwnerDelete": "Only the owner can delete this organization.",
  "organization.tooManySeats": "Choose between 1 and 500 seats.",
  "organization.seatsBelowMembers": "Seats cannot be fewer than current members.",
  "organization.alreadySubscribed":
    "This team already has a subscription. Use billing to change seats.",
  "organization.teamPrice": "$8",
  "organization.perMonth": "per seat / month",
  "organization.perYear": "per seat / year",
  "organization.yearlyPrice": "$76",
  "organization.seatUsage": "{used} of {seats} seats used",
  "organization.noPendingInvites": "No pending invitations.",
  "organization.inviteExpires": "Expires {date}",
  "organization.roleHint":
    "Owners manage billing and roles. Admins manage members and invitations.",
  "organization.settingsTitle": "Organization settings",
  "organization.manageSeats": "Change seats in the billing portal.",
  "organization.wrongAccount": "Signed in as {current}. This invitation is for {email}.",
  "organization.switchAccount": "Use another account",

  "public.madeWith": "Made with YourCV",
  "public.openFull": "Open full CV",
  "public.print": "Print",
  "public.notFound": "This CV is private or does not exist.",

  "cv.present": "Present",
  "cv.summary": "Summary",
  "cv.experience": "Experience",
  "cv.education": "Education",
  "cv.projects": "Projects",
  "cv.skills": "Skills",
  "cv.languages": "Languages",
  "cv.certifications": "Certifications",
  "cv.awards": "Awards",
  "cv.links": "Links",
  "cv.contact": "Contact",
  "cv.email": "Email",
  "cv.phone": "Phone",
  "cv.location": "Location",

  "legal.privacy": "Privacy",
  "legal.terms": "Terms",
  "legal.lastUpdated": "Last updated October 2026",
  "legal.privacyBody":
    "We store the CV content you enter, the images you upload, and your account email. We use Stripe for payments and do not store card details. You can export or delete your data from Settings at any time.",
  "legal.refunds": "Refunds",
  "legal.refundsBody":
    "Pro subscriptions can be cancelled at any time in the billing portal. Contact us within 14 days of a charge for a refund.",
  "legal.termsBody":
    "YourCV is provided as is. You own the content you create. Do not upload unlawful material. Pro subscriptions renew until cancelled in the billing portal.",

  "errors.generic": "Something went wrong. Try again.",
  "errors.unauthorized": "Please sign in.",
  "errors.notFound": "Not found.",
  "errors.proRequired": "This template is available on Pro.",
  "errors.resumeLimit": "You have reached your CV limit.",
  "errors.storageLimit": "You have reached your storage limit.",
  "errors.appPasswordLimit": "You can keep ten active app passwords.",
  "errors.validation": "Check the highlighted fields.",
  "errors.network": "Network problem. Check your connection.",
  "errors.slugTaken": "That link is already taken.",
  "errors.fileType": "Use a JPEG, PNG, WebP, or AVIF image.",
  "errors.fileSize": "Images must be 5 MB or smaller.",
  "errors.stripe": "Billing is unavailable right now.",
  "errors.forbidden": "You do not have access to that.",
  "errors.orgSubscription": "Subscribe to the team plan before inviting members.",
  "errors.orgSeatLimit": "No seats are available.",
  "errors.lastOwner": "Keep at least one owner in the organization.",
  "errors.orgOwner": "Transfer or delete your organization before deleting your account.",
  "errors.alreadyMember": "That person is already a member.",
  "errors.alreadyInvited": "That person already has a pending invitation.",
  "errors.inviteUsed": "This invitation was already used.",
  "errors.inviteExpired": "This invitation has expired.",

  "locale.en": "English",
  "locale.vi": "Tiếng Việt",
} as const;

export type MessageKey = keyof typeof en;
export type Messages = Record<MessageKey, string>;
